<template>
  <!-- 添加物模型 -->
  <div class="">
    <v-dialog
      class="popbox"
      name="dialog2"
      v-model="isShow"
      :title="updataOrview == 2 ? '查看自定义功能' : '编辑自定义功能'"
      close-on-click-modal
      :modal="true"
      :width="668"
      @open="open"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      confirmButtonText="确定"
      append-to-body
    >
      <v-form ref="form" :model="ruleForm" :rules="rules" >
        <v-form-item prop="function_type" key="functionType">
          <template slot="label">
            <span class="required">*</span>
            <span>功能类型</span>
          </template>
          <v-radio class="options" disabled @change="typeChange" v-model="functiontype" name="functionType" :options="functionTypeOptions"></v-radio>
        </v-form-item>
        <v-form-item  prop="name" key="name">
          <template slot="label">
            <span class="required">*</span>
            <span>功能名称</span>
          </template>
          <v-input type="text" :disabled="updataOrview == 2" name="name" v-model="ruleForm.name"></v-input>
        </v-form-item>
        <v-form-item  prop="identifier" key="identifier">
          <template slot="label">
            <span class="required">*</span>
            <span>标识符</span>
          </template>
          <v-input type="text" :disabled="updataOrview == 2" name="identifier" v-model="ruleForm.identifier"></v-input>
        </v-form-item>
        <v-form-item prop="data_type"  v-if="functiontype == 'properties'" key="data_type">
          <template slot="label">
            <span class="required">*</span>
            <span>数据类型</span>
          </template>
          <v-select :disabled="updataOrview == 2" id="data_type" insertContains="data_type" name="data_type" v-model="ruleForm.data_type" :options="dataTypeOptins"></v-select>
        </v-form-item>

        <!-- <v-form-item prop="unit" :required="false" v-if="functiontype == 'properties'" key="unit">
          <template slot="label">
            <span class="required"></span>
            <span>单位</span>
          </template>
          <v-input type="text" :disabled="updataOrview == 2" name="unit" v-model="ruleForm.unit"></v-input>
        </v-form-item> -->

        <v-form-item prop="input_data" :required="false"  v-if="functiontype == 'service'" key="input_data">
          <template slot="label">
            <span class="required"></span>
            <span>输入参数</span>
            <div class="handle-button"><v-button :disabled="updataOrview == 2" size="S" type="text" name="btn12" @click="openAddModel('input')">+增加参数</v-button></div>
          </template>
            <div v-for="(item,index) in ruleForm.input_data" :key="index">
              <div class="parameter mb10" ><span>{{ item.identifier }}：{{item.name}}</span></div>
              <span class="parame-edit-del">
                <span :class="updataOrview != 2 ? 'handle-button':''"><v-button size="S" type="text" name="btn3" slot="reference" @click="openUpdateModel(item, index, 'input')">{{updataOrview == 2 ? '查看' : '编辑'}}</v-button></span>
                <span class="handle-button"><v-button size="S" v-if="updataOrview != 2" type="text" name="btn4" slot="reference" @click="delParam(index,'input')">删除</v-button></span>
              </span>
            </div>
        </v-form-item>

        <v-form-item prop="output_data" :required="false" v-if="functiontype != 'properties'" key="output_data">
          <template slot="label">
            <span class="required"></span>
            <span>输出参数</span>
            <div class="handle-button"><v-button size="S" :disabled="updataOrview == 2" type="text" name="btn2" @click="openAddModel('output')">+增加参数</v-button></div>
          </template>
          <div v-for="(item,index) in ruleForm.output_data" :key="index">
            <div class="parameter mb10" ><span>{{ item.identifier }}：{{item.name}}</span></div>
            <span class="parame-edit-del">
              <span :class="updataOrview != 2 ? 'handle-button':''"><v-button size="S" type="text" name="btn2" slot="reference" @click="openUpdateModel(item, index, 'output')">{{updataOrview == 2 ? '查看' : '编辑'}}</v-button></span>
              <span class="handle-button"><v-button size="S" v-if="updataOrview != 2" type="text" name="btn2" slot="reference" @click="delParam(index,'output')">删除</v-button></span>
            </span>
          </div>
        </v-form-item>

        <v-form-item  prop="desc" :required="false" key="desc">
          <template slot="label">
            <span class="required"></span>
            <span>备注</span>
          </template>
          <v-input type="textarea" :disabled="updataOrview == 2" class="Description" name="desc" :maxlength="200" show-word-limit v-model="ruleForm.desc"></v-input>
        </v-form-item>
      </v-form>
      <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>
    </v-dialog>
    <AddParam  :showInputDialog.sync="addloading" ref="add" @changeinputDataList="changeinputDataList" :ParamData="ParamData"></AddParam>
    <UpdateParam  :showInputDialog.sync="Updateloading" ref="Update" :updataOrview="updataOrview" :propData="propData" :ParamData="ParamData" :updateIndex="updateIndex" @updatainputDataList="updatainputDataList"></UpdateParam>
  </div>

</template>

<script>
import { copy } from '@/common/libs/utils';
import AddParam from "@/components/product/physicalmodel/add-param.vue";
import UpdateParam from "@/components/product/physicalmodel/updata-param.vue";

export default {
  components: {AddParam, UpdateParam},
  props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    updataOrview:{},
    id:{},
    functiontype:{}
  },
  data() {
    return {
      rules: {
        name: copy([{
            type: "nameInput"
        }]),
        identifier: copy([{
            type: "identifier"
        }]),
      },
      ruleForm:{
        function_type: 'properties',   //功能类型：PROPERTIES 属性；EVENT 事件；SERVICE 服务
        name: '',     //名称
        identifier: '',  //标识
        desc: '',   //备注
        data_type:'',
        // unit:'',
        input_data:[],
        output_data:[]
      },

      functionTypeOptions:[
          {
            label: "属性",
            value: 'properties'
          },
          {
            label: "服务",
            value: 'service'
          },
          {
            label: "事件",
            value: 'event'
          }
      ],
      dataTypeOptins:[
          {
              label: "int(整数)",
              value: 'int'
          },
          {
              label: "float64(浮点数)",
              value: 'float64'
          },
          {
              label: "string(字符串)",
              value: 'string'
          },
          {
              label: "bool(布尔值)",
              value: 'bool'
          },
          {
              label: "array(数组)",
              value: 'array'
          },
          {
              label: "struct(结构)",
              value: 'struct'
          }
        ],
      addloading:false,
      Updateloading: false,
      isShow:false,
      updateIndex: 0,
      propData:{},
      originalData:{},
      function_type1:'',
      ParamData: [],
      upTips:true,
      datatype:'',
    };
  },
  created() {
    this.originalData = copy(this.ruleForm)
  },
  watch:{
    showInputDialog(newVal){
      this.isShow = newVal
    },
  },
  methods: {
    open(){
      this.getdata()
    },
    async getdata(){
      const subdata = {
        id : this.id
      }
      if (this.updataOrview === 1) {
        //编辑
        const res = await this.$getData("/td/td-iot-api/iot/thing/draft/v1",subdata);
        this.ruleForm = copy(res.data);
      } else {
        const res = await this.$getData("/td/td-iot-api/iot/thing/v1",subdata);
        this.ruleForm = copy(res.data);
      }

    },
    typeChange(value){
      if(this.function_type1 != value){
        this.ruleForm = copy(this.originalData)
        this.ruleForm.function_type = value
      }
      this.function_type1 = value
    },
    openAddModel(type){
      this.datatype = type
      this.ParamData = type == 'input' ?  this.ruleForm.input_data : this.ruleForm.output_data
      this.addloading = !this.addloading
    },
    openUpdateModel(data,index, type){
      this.datatype = type
      this.propData = data
      this.updateIndex = index
      this.ParamData = type == 'input' ?  this.ruleForm.input_data : this.ruleForm.output_data
      this.Updateloading = !this.Updateloading
    },
    changeinputDataList(data){
      if(this.datatype == 'input'){
        let list = this.ruleForm.input_data == null ? [] : copy(this.ruleForm.input_data)
        list.push(data)
        this.ruleForm.input_data = copy(list)
      }else{
        let list = copy(this.ruleForm.output_data)
        list.push(data)
        this.ruleForm.output_data = copy(list)
      }
    },
    updatainputDataList(data,index){
      if(this.datatype == 'input'){
        let list = this.ruleForm.input_data == null ? [] : copy(this.ruleForm.input_data)
        list.splice(index, 1 , data)
        this.ruleForm.input_data = copy(list)
      }else{
        let list = copy(this.ruleForm.output_data)
        list.splice(index, 1 , data)
        this.ruleForm.output_data = copy(list)
      }
    },
    delParam(index ,type){
      if(type == 'input'){
        this.ruleForm.input_data.splice(index, 1)
      }else{
        this.ruleForm.output_data.splice(index, 1)
      }
    },
    handleConfirm() {
      // if (this.ruleForm.input_data?.length == 0 && this.functiontype == 'service') {
      //   this.$message.error("请检查输入参数")
      //   return
      // }
      // if (this.ruleForm.output_data?.length == 0 && this.functiontype != 'properties') {
      //   this.$message.error("请检查输出参数")
      //   return
      // }
      if(this.updataOrview == 2){
        this.$emit('update:showInputDialog',false)
        return
      }
      const valid = this.$refs.form.submitForm();
      if (valid === false) {
        return;
      }
      let submitData = { ...this.ruleForm, model_type: 'PRODUCT' };
      // submitData.id = Number(this.ruleForm.ID)
      this.$put("/td/td-iot-api/iot/thing/draft/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit('getData')
          this.$message.success(res.msg);
        }
        else {
          this.$message.error(res.msg);
        }
      });
      this.$emit('update:showInputDialog',false)
    },
    handleAfterClose() {
      this.$emit('update:showInputDialog',false)
      this.ruleForm = copy(this.originalData)
    }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
</style>
